import { useContext, useEffect, useMemo, useState } from "react";
import { SydFilterContext } from "src/components/Common/UI/SydFilter/SydFilterContext";

import { useTranslation } from "react-i18next";
import { convertApiDataToReactTableData, convertApiHeaderToReactTableHeader } from "src/components/Common/UI/DndTable/UtilFunctions";
import { useGetPhoneLineViaID } from "src/pages/Configuration/LinesAndNodesConfiguration/PhoneLine/api/getPhoneLineViaID";

// All your logic is here
export const usePhoneLinesTable = ({unitID} : usePhoneLinesTableProps) => {
  const { activeFilters } = useContext(SydFilterContext);
  const [modalEvent, setModalEvent] = useState<IEvent>({action: "",selectedRows: [],});
  const [selectedRowsOfTable, setSelectedRowsOfTable] = useState<IGetPhoneLineViaUnitID[]>([]);
  const getPhoneLinesViaUnitIDQuery = useGetPhoneLineViaID({phoneLineId: unitID})
  const { t } = useTranslation();

  const loadingDone = [getPhoneLinesViaUnitIDQuery].every(({ isFetching }) => !isFetching);

  const errorData = [getPhoneLinesViaUnitIDQuery].filter(({ isError }) =>isError ? true : false);

  const dataTypes = [
    { id: 0, apiType: "Default", frontType: "", frontDisplayFormat: "" },
    { id: 1, apiType: "Integer", frontType: "number", frontDisplayFormat: "" },
    { id: 2, apiType: "Double", frontType: "number", frontDisplayFormat: "" },
    { id: 3, apiType: "Date", frontType: "date", frontDisplayFormat: "YYYY-MM-DD HH:mm:ss", sourceDisplayFormat: "YYYY-MM-DDTHH:mm:ss" },
    { id: 4, apiType: "String", frontType: "string", frontDisplayFormat: "" },
    { id: 5, apiType: "yyyyMMdd", frontType: "date", frontDisplayFormat: "YYYY-MM-DD", sourceDisplayFormat: "YYYYMMDD" },
    { id: 6, apiType: "Boolean", frontType: "boolean", frontDisplayFormat: "" },
    { id: 7, apiType: "IntegerTime", frontType: "date", frontDisplayFormat: "HH:mm:ss", sourceDisplayFormat: "seconds" },
    { id: 8, apiType: "yyyyMM", frontType: "date", frontDisplayFormat: "MMM YYYY", sourceDisplayFormat: "YYYYMM" }
  ];

  const data = getPhoneLinesViaUnitIDQuery.data ? getPhoneLinesViaUnitIDQuery.data : [];

  const columnData = [
    {
      columnName: "id",
      columnDisplayName: "#",
      visible: true,
      columnOrder: 1,
      isDraggable: false,
      columnPhoneType: "String",
    },
    {
      columnName: "lineTypeName",
      columnDisplayName: "Είδος",
      visible: true,
      columnOrder: 2,
      isDraggable: false,
      columnPhoneType: "String",
    },
    {
      columnName: "provider",
      columnDisplayName: "Πάροχος",
      visible: true,
      columnOrder: 3,
      isDraggable: false,
      columnPhoneType: "String",
    },
    {
      columnName: "phoneNumber",
      columnDisplayName: "Αριθμός",
      visible: true,
      columnOrder: 4,
      isDraggable: false,
      columnPhoneType: "String",
    },
    {
      columnName: "usedBy",
      columnDisplayName: "Χρήση",
      visible: true,
      columnOrder: 5,
      isDraggable: false,
      columnPhoneType: "String",
    },
  ]

  const columns = useMemo(() => {
    console.log("columnData",columnData)
    return convertApiHeaderToReactTableHeader(
      columnData ,
      dataTypes
    );
  }, []);

  const closeActionModal = () => {
    setModalEvent({ action: "", selectedRows: [] });
  };

  const getModalTitleByAction = (): string => {
    let title = "";
    switch (modalEvent.action) {
      case "create":
        title = t("Δημιουργία Τηλεφωνικής γραμμής");
        break
      case "edit":
        title = t("Επεξεργασία Τηλεφωνικής γραμμής");
        break
      case "delete":
        title = t("Διαγραφή Τηλεφωνικής γραμμής");
        break;
      case "bulkdelete":
        title = t("Μαζική Διαγραφή Τηλεφωνικής γραμμής");
        break;
      default:
        break;
        
    }
    return title;
  };

  const actionEvent = (event: IEvent) => {
    const selectedRows: number[] = selectedRowsOfTable[0]
      ? [...[selectedRowsOfTable[0].id]]
      : [];
    console.log(
      "selectedRows",
      selectedRows,
      "selectedRowOfTable",
      selectedRowsOfTable,
      "selectedRowOfTable[0]",
      selectedRowsOfTable[0]
    );
    setModalEvent({ action: event.action, selectedRows: selectedRows });
  };



  useEffect(() => {
    getPhoneLinesViaUnitIDQuery.refetch();
  }, [activeFilters]);

  return {
    data,
    columns,
    loadingDone,
    selectedRowsOfTable,
    setSelectedRowsOfTable,
    t,
    modalEvent,
    actionEvent,
    closeActionModal,
    getModalTitleByAction,
  };
};

interface usePhoneLinesTableProps {
  unitID: number;
}

